'use client';

import type { OverlayTriggerState} from '@react-stately/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import type { ReactNode} from 'react';
import { createContext, useContext } from 'react';
import { MemoryRouter } from 'react-router-dom';

import type { MenuItemType } from '@zoomit/web-kit';

type Props = {
  children: ReactNode;
  menuItems: Array<MenuItemType>;
};

type MenuContextType = {
  menuItems: Array<MenuItemType>;
  mobileMenuTriggerState: OverlayTriggerState;
  initialEntry: string;
};

const DefaultMenuContext = createContext<MenuContextType | null>(null);

export const useDefaultMenuContext = () => useContext(DefaultMenuContext) as MenuContextType;

const DefaultMenuModuleProvider = (props: Props) => {
  const { children, menuItems } = props;
  const mobileMenuTriggerState = useOverlayTriggerState({});
  const initialEntry = '/home';

  return (
    <DefaultMenuContext.Provider value={{ mobileMenuTriggerState, initialEntry, menuItems }}>
      <MemoryRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
        initialEntries={[initialEntry]}
      >
        {children}
      </MemoryRouter>
    </DefaultMenuContext.Provider>
  );
};

export default DefaultMenuModuleProvider;
